import styled from 'styled-components'
import Link from '../../../../utils/Link'

const LogoutLink = styled(Link)`
  color: ${props => props.theme.email.full.color};
  font-size: 14px;
  text-decoration: underline;
`

const ButtonLink = styled(Link)`
  padding: 7px 17px;
  border-width: 1px;
  border-style: solid;
  border-radius: 5px;
  height: 16px;
  line-height: 16px;
  font-weight: 700;
  font-size: 12px;
`

const InboxLink = styled(ButtonLink)`
  margin-right: 10px;
  border-color: #8fb9ce;
  background-color: #ffd640;
  color: #403f3f;

  &:hover {
    text-decoration: none;
    background-color: #ffdd40;
  }
`

const MessageLink = styled(ButtonLink)`
  border-color: #beced7;
  background-color: #26a3e0;
  color: #fff;

  &:hover {
    text-decoration: none;
    background-color: #1f9dd9;
    color: #fff;
  }
`

export {
  LogoutLink, MessageLink, InboxLink
}
